import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SIGNIN,
  FORGETPASSWORD,
  ADD_ARTICLE,
  WELCOME,
  USERS,
  ARTICLES,
  EDIT_ARTICLE,
  RECEPTIONS,
  CONTAINER,
  VALIDCONTAINERS,
  RECLASSIFY,
  CONTAINER_CLASSIFICATION,
  CONTAINER_AUDIT,
} from './routes';

export function useNavigationCore() {
  const navigate = useNavigate();

  const goToSignIn = useCallback(() => {
    navigate(SIGNIN);
  }, [navigate]);

  const goToForgetPassword = useCallback(() => {
    navigate(FORGETPASSWORD);
  }, [navigate]);

  const goToWelcome = useCallback(() => {
    navigate(WELCOME);
  }, [navigate]);

  const goToUsers = useCallback(() => {
    navigate(USERS);
  }, [navigate]);

  const goToUser = useCallback(
    (id: string) => {
      navigate(`${USERS}/${id}`);
    },
    [navigate]
  );

  const goToAddArticle = useCallback((copy: boolean = false) => {
    if (copy) {
      navigate(`${ADD_ARTICLE}?copy=true`);
    } else {
      navigate(ADD_ARTICLE);
    }
  }, [navigate]);

  const goToEditArticle = useCallback(() => {
    navigate(EDIT_ARTICLE);
  }, [navigate]);

  const goToArticles = useCallback(() => {
    navigate(ARTICLES);
  }, [navigate]);

  const goToReceptions = useCallback(() => {
    navigate(RECEPTIONS);
  }, [navigate]);

  const goToValidContainers = useCallback(() => {
    navigate(VALIDCONTAINERS);
  }, [navigate]);

  const goToReceptionContainers = useCallback(
    (id: number) => {
      navigate(`${RECEPTIONS}/${id}/containers`);
    },
    [navigate]
  );

  const goToContainerProducts = useCallback(
    (id: number) => {
      navigate(`${CONTAINER}/${id}/products`);
    },
    [navigate]
  );

  const goToReclassify = useCallback(() => {
    navigate(RECLASSIFY);
  }, [navigate]);

  const goToContainerClassification = useCallback(() => {
    navigate(CONTAINER_CLASSIFICATION);
  }, [navigate]);

  const goToContainerAudit = useCallback(() => {
    navigate(CONTAINER_AUDIT);
  }, [navigate]);

  return {
    goToSignIn,
    goToForgetPassword,
    goToWelcome,
    goToUsers,
    goToUser,
    goToAddArticle,
    goToEditArticle,
    goToArticles,
    goToReceptions,
    goToReceptionContainers,
    goToValidContainers,
    goToContainerProducts,
    goToReclassify,
    goToContainerClassification,
    goToContainerAudit,
  };
}
